module.exports = __webpack_public_path__ + "img/garden.be5030ca.webp";